module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "update-firebase-modal"
  }, [_c('div', {
    staticClass: "update-firebase-modal__overlay",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "update-firebase-modal__modal"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 4L4 12M4 4L12 12",
      "stroke": "#666",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content-modal"
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "64",
      "height": "64",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 2L2 7L12 12L22 7L12 2Z",
      "stroke": "#423799",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2 17L12 22L22 17",
      "stroke": "#423799",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2 12L12 17L22 12",
      "stroke": "#423799",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("Update from Firebase to API")]), _vm._v(" "), _c('p', {
    staticClass: "modal-description"
  }, [_vm._v("\n        This will update all missing race resumes from Firebase data. The process will check each runner and create race resumes for those that don't exist.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "toggle-container"
  }, [_c('label', {
    staticClass: "toggle-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.overwriteExisting),
      expression: "overwriteExisting"
    }],
    staticClass: "toggle-checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.overwriteExisting) ? _vm._i(_vm.overwriteExisting, null) > -1 : (_vm.overwriteExisting)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.overwriteExisting,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.overwriteExisting = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.overwriteExisting = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.overwriteExisting = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "toggle-text"
  }, [_vm._v("Overwrite existing race resumes if found")])])]), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "btn btn--gray",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "btn-loader"
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.loading ? 'Processing...' : 'Update'))])])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1da4749a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/UpdateFromFirebaseModal.vue
// module id = 1676
// module chunks = 2